import cn from 'classnames'
import styled from '@emotion/styled'
import { Flex } from 'shared/ui'
import Action from './Action'

const Actions = ({
  className,
  hideBcc = false,
  hideCc = false,
  hideFrom = false,
  hideSubject = false,
  onClick,
}) => {
  return (
    <Flex className={cn('actions grui ml-4', className)}>
      {!hideSubject && <Action name={'subject'} onClick={onClick} />}
      {!hideFrom && (
        <Action name={'from'} className="grui ml-10" onClick={onClick} />
      )}
      {!hideCc && (
        <Action name={'cc'} className="grui ml-10" onClick={onClick} />
      )}
      {!hideBcc && (
        <Action name={'bcc'} className="grui ml-10" onClick={onClick} />
      )}
    </Flex>
  )
}

export default styled(Actions)`
  line-height: 24px;
  transform: translateY(-1px); /* visually center-align with rest of items */
`
